import {FETCH_HELP_REQUEST, FETCH_HELP_SUCCES, FETCH_HELP_ERROR} from '../constants/Help'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function help(state = initialState, action) {
  switch (action.type) {
      case FETCH_HELP_REQUEST:
        return {...state, isLoading: true};
      case FETCH_HELP_SUCCES:
        return {...state, item: action.payload, isLoading: false};
      case FETCH_HELP_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/help.js